<template>
  <el-dialog :visible.sync="innerVisible" :title="messageTitle" width="450px" custom-class="cargo-form-dialog" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="form" label-width="85px" label-position="left" class="cargo-form">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Remarks')+'：'">
            <el-input v-model="content" type="textarea" :rows="5" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" style="padding:10px;">
      <el-button v-show="showConfirmBtn" type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  name: 'ConfirmDialogWindow',
  components: { },
  props: {
    visible: { type: Boolean, default: () => false },
    showConfirmBtn: { type: Boolean, default: () => false },
    messageTitle: { type: String, default: () => ('') },
    confirmCallBack: { type: Function, default: () => (null) },
    content: { type: String, default: () => ('') }
  },
  data() {
    return {
      innerVisible: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
  },
  methods: {
    handleSubmit() {
      if (this.confirmCallBack) {
        this.confirmCallBack()
      }
      this.handleClose()
    },
    handleClose() {
      this.innerVisible = false
    }
  }
}
</script>
<style lang="scss">
  .cargo-form-dialog{
    .el-dialog{
      &__header,&__body,&__footer{
        padding:10px 15px!important;
      }
      &__title{
        vertical-align: middle;
      }
      &__headerbtn{
        top:15px;
        right:15px;
      }
    }
  }
  .cargo-form{
    .el-form-item {
      &.label-none {
        .el-form-item__content{
          margin-left: 0;
        }
      }
    }
  }
</style>
